// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateSpaClaim} from '../../shared/repositories';

export const putSpaClaim = claim =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await updateSpaClaim(claim);

            successAlertBar(translate('SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED'));
            dispatch(routerActions.push('/tcsm/wip'));

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/action-creators/put-spa-claim.js